import Vue from "vue"
import VueRouter from "vue-router"
import store from "@/store"
import { Types } from "@/store/modules/auth"
import DashboardManager from "@/components/manager/pages/Dashboard"
import DashboardMe from "@/components/me/pages/Dashboard"
import LoginManager from "@/components/manager/pages/Login"
import LoginMe from "@/components/me/pages/Login"
import RegistrationManager from "@/components/manager/pages/Registration"
import MessageBox from "@/components/common/pages/MessageBox"
import RegistrationMe from "@/components/me/pages/Registration"
//import { comeFromManager } from "@/helpers";
import { comeFromMe } from "@/helpers"
import ModerationToken from "@/components/manager/pages/ModerationToken"
import ValidationToken from "@/components/me/pages/ValidationToken"
import Recover from "@/components/common/pages/Recover"

Vue.use(VueRouter)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters[Types.getters.IS_AUTHENTICATED]) {
    next()
  } else {
    if (to.path.match(/(registration|login)$/)) {
      window.localStorage.clear()
      window.location = to.path
      return
    }
    next(`/${window.location.search}`)
  }
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters[Types.getters.IS_AUTHENTICATED]) {
    next()
  } else {
    next(`login${window.location.search}`)
  }
}

let routes

if (!comeFromMe()) {
  routes = [
    { path: "*", component: DashboardManager, beforeEnter: ifAuthenticated },
    {
      path: "/login",
      component: LoginManager,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: "/recover",
      component: Recover,
    },
    {
      path: "/registration",
      component: RegistrationManager,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: "/message",
      component: MessageBox,
    },
    {
      path: "/moderation/:token",
      component: ModerationToken,
    },
  ]
} else {
  routes = [
    { path: "*", component: DashboardMe, beforeEnter: ifAuthenticated },
    { path: "/login", component: LoginMe, beforeEnter: ifNotAuthenticated },
    {
      path: "/recover",
      component: Recover,
    },
    {
      path: "/registration",
      component: RegistrationMe,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: "/review/validation/:token",
      component: ValidationToken,
    },
    {
      path: "/message",
      component: MessageBox,
    },
  ]
}

const router = new VueRouter({
  mode: "history",
  routes,
})

export default router
